import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Scroll from 'react-scroll';
import { isFreshPageLoad } from './NavigationTracker';



var scroller = Scroll.scroller;
var scroll = Scroll.animateScroll;

const MAX_RESTORE_ATTEMPTS = 20;

const ScrollingSaver = (props) => {
    const history = useHistory();

    useEffect(() => {
        let cancelled = false;

        const getTheScroll = () => {
            sessionStorage.setItem(props.pagNam, window.scrollY);
        }

        // Async content (search results, restaurant menu, ...) may not have
        // rendered yet when this mounts, so the page might not be tall enough
        // to scroll to the saved position. Retry until it is, or give up.
        // Bails out via `cancelled` if the page is left before content loads,
        // so a stale scroll doesn't land on whatever page comes next.
        const waitForContentThenScroll = (targetY, attemptsLeft) => {
            if (cancelled) return;

            const pageIsTallEnough = document.body.scrollHeight - window.innerHeight >= targetY;

            if (pageIsTallEnough || attemptsLeft <= 0) {
                window.scrollTo(0, targetY);
                return;
            }

            requestAnimationFrame(() => waitForContentThenScroll(targetY, attemptsLeft - 1));
        }

        const savedScroll = sessionStorage.getItem(props.pagNam);
        const shouldRestore = savedScroll && history.action === "POP" && !isFreshPageLoad();
        const stillWaitingForContent = shouldRestore && props.contentReady === false;

        if (stillWaitingForContent) {
            // התוכן עוד לא קיים - לא רושמים כאן listener שישמור גלילה,
            // אחרת ערך-הביניים (לפני שהתוכן נטען) ידרוס את המיקום השמור
            // עוד לפני שהניסיון הבא (עם contentReady=true) יספיק לשחזר אותו.
            return;
        }
        else if (shouldRestore) {
            waitForContentThenScroll(Number(savedScroll), MAX_RESTORE_ATTEMPTS);
        }
        else if (savedScroll) {
            sessionStorage.removeItem(props.pagNam);
        }

        window.addEventListener("scroll", getTheScroll);
        return () => {
            cancelled = true;
            window.removeEventListener("scroll", getTheScroll);
        }

    }, [props.pagNam, props.contentReady]);

    return (<></>)

}

export default ScrollingSaver;
